"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var Converter_1 = require("./Converter");

var ExecuteMethod_1 = require("./ExecuteMethod");

var RestAdapter_1 = require("./RestAdapter");

var Repository =
/** @class */
function () {
  function Repository(targetType, resourceType, adapter, converter) {
    var _this = this;

    this.toString = function () {
      return "[Repository<" + _this._targetType.name + "> " + _this._resourceType + "]";
    };

    if (!targetType) {
      throw new TypeError('Expected argument "targetType" to be a class');
    } // noinspection SuspiciousTypeOfGuard


    if (!resourceType || typeof resourceType !== 'string') {
      throw new TypeError('Expected argument "resourceType" to be of type string');
    }

    if (!adapter) {
      throw new TypeError('Expected argument "adapter" to be an instance of AdapterInterface');
    }

    this._targetType = targetType;
    this._converter = converter || new Converter_1.Converter();
    this._adapter = adapter;
    this._resourceType = resourceType;
  }

  Repository.prototype.findAll = function () {
    var _this = this;

    return this._adapter.findAll(this._resourceType).then(function (result) {
      return _this._converter.convertCollection(_this._targetType, result);
    });
  };

  Repository.prototype.findByIdentifier = function (identifier) {
    var _this = this;

    return this._adapter.findByIdentifier(this._resourceType, identifier).then(function (result) {
      return _this._converter.convertSingle(_this._targetType, result);
    });
  };
  /**
   * Perform a GET or POST request to the given API path
   *
   * @param {string} subPath
   * @param {ExecuteMethod} method
   * @param {I} body
   * @return {Promise<T[] | Map<string, T> | T | null>}
   */


  Repository.prototype.execute = function (subPath, method, body) {
    var _this = this;

    if (method === void 0) {
      method = ExecuteMethod_1.ExecuteMethod.GET;
    }

    if (!(this._adapter instanceof RestAdapter_1.RestAdapter)) {
      throw new TypeError('Not implemented');
    }

    var onFulfilled = function onFulfilled(result) {
      if (Array.isArray(result)) {
        return _this._converter.convertCollection(_this._targetType, result);
      } else {
        return _this._converter.convertSingle(_this._targetType, result);
      }
    };

    var requestPath = this._resourceType + '/' + subPath;

    if (method === 'GET') {
      return this._adapter.execute(requestPath).then(onFulfilled);
    } else if (method === 'POST') {
      if (arguments.length < 3) {
        throw new ReferenceError('Missing request body');
      }

      return this._adapter.execute(requestPath, method, body).then(onFulfilled);
    } else {
      throw new TypeError("Method '" + method + "' is not implemented");
    }
  };

  return Repository;
}();

exports.Repository = Repository;